import { render, staticRenderFns } from "./GotoSpecificationsButton.vue?vue&type=template&id=2b9dfb4e&scoped=true"
import script from "./GotoSpecificationsButton.vue?vue&type=script&lang=js"
export * from "./GotoSpecificationsButton.vue?vue&type=script&lang=js"
import style0 from "./GotoSpecificationsButton.vue?vue&type=style&index=0&id=2b9dfb4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9dfb4e",
  null
  
)

export default component.exports